import './_vertical-bar-chart.scss';
import { Chart } from 'chart.js/auto';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function VerticalBarChart() {
    const barChart = document.querySelectorAll('.bar-chart');

    if (barChart.length > 0) {
        barChart.forEach((bar, index) => {
            let data: any;
            const results: any = [];
            const resultsArray: any = [];
            let datasets: any = [];
            let chart: any;
            const dataChart = bar.querySelector('.data-bar-chart') as HTMLScriptElement;
            const labelTooltip = bar.querySelector('.label-tooltip') as HTMLElement;
            const mask = bar.querySelector('.mask') as HTMLElement;

            if (dataChart) {
                try {
                    data = JSON.parse(dataChart.innerHTML);
                } catch (e) {
                    data = [];
                }
            }

            data.forEach((item: any) => {
                const key = Object.keys(item)[0];
                results.push(item[key]);
            });

            if (results) {
                results.forEach((el: any) => {
                    el.values.forEach((item: any) => {
                        resultsArray.push(item);
                    });
                });

                if (data.length > 1) {
                    datasets = resultsArray.reduce(function (acc: any, cur: any) {
                        let object = acc.find((x: any) => x.label == cur.title);
                        if (object == null) {
                            object = {
                                label: cur.title,
                                data: [cur.value],
                                backgroundColor: [cur.color],
                                borderColor: [cur.color],
                                titlesTooltip: [cur.title],
                            };

                            acc.push(object);
                        } else {
                            object.data.push(cur.value);
                        }

                        return acc;
                    }, []);
                } else {
                    results.forEach((result: any) => {
                        const datasetData = result.values.map((el: any) => el.value);
                        const datasetColor = result.values.map((el: any) => el.color);

                        datasets.push({
                            data: datasetData,
                            backgroundColor: datasetColor,
                            hoverBackgroundColor: datasetColor,
                            titlesTooltip: result.values.map((el: any) => el.title),
                        });
                    });
                }
            }

            function createLegend() {
                const legend = bar.querySelector('.bar-legend') as HTMLElement;
                results[0].values.forEach((item: any) => {
                    const legendItem = document.createElement('div');
                    legendItem.classList.add('legend-item');
                    const tile = document.createElement('div');
                    tile.classList.add('tile');
                    tile.style.backgroundColor = item.color;
                    const legendLabel = document.createElement('div');
                    legendLabel.classList.add('label');
                    legendLabel.textContent += item.title;

                    legendItem.appendChild(tile);
                    legendItem.appendChild(legendLabel);
                    legend.appendChild(legendItem);
                });
            }

            function clearUi() {
                const titlesTooltip = bar.querySelectorAll('.tooltip-title');
                const descriptionsTooltip = bar.querySelectorAll('.tooltip-description');

                titlesTooltip && titlesTooltip.forEach(item => item.remove());
                descriptionsTooltip && descriptionsTooltip.forEach(item => item.remove());
            }

            function closeModal() {
                const closeBtn = labelTooltip.querySelector('.close-btn') as HTMLElement;

                closeBtn.addEventListener('click', () => {
                    mask.classList.add('d-none');
                    labelTooltip.classList.add('d-none');
                    document.body.style.overflow = 'scroll';
                });

                closeBtn.addEventListener('keypress', function (e) {
                    if (e.code === 'Enter') {
                        mask.classList.add('d-none');
                        labelTooltip.classList.add('d-none');
                        document.body.style.overflow = 'scroll';
                    }
                });

                mask.addEventListener('click', () => {
                    mask.classList.add('d-none');
                    labelTooltip.classList.add('d-none');
                    document.body.style.overflow = 'scroll';
                });

                document.addEventListener('keydown', e => {
                    if (e.key === 'Escape') {
                        mask.classList.add('d-none');
                        labelTooltip.classList.add('d-none');
                        document.body.style.overflow = 'scroll';
                    }
                });
            }

            function initChartDsk() {
                let ctx = bar.querySelector('#bar-chart-content') as any;
                const allLabels = results.reduce((acc: any, item: any) => acc.concat(item.values.map((el: any) => el.title)), []);

                chart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: data.length > 1 ? data.map((item: any) => Object.keys(item)[0]) : allLabels,
                        datasets: datasets,
                    },
                    options: {
                        datasets: {
                            bar: {
                                barPercentage: 0.95,
                            },
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        scales: {
                            x: {
                                grid: {
                                    display: false,
                                },
                                ticks: {
                                    display: false,
                                },
                            },
                            y: {
                                grid: {
                                    display: true,
                                    color: '#ECE9F1',
                                    tickColor: 'transparent',
                                    tickLength: 39,
                                },
                                border: {
                                    display: false,
                                },
                                beginAtZero: true,
                                display: true,
                                ticks: {
                                    autoSkipPadding: 50,
                                    callback: function (value: number | string) {
                                        const numValue = Number(value);
                                        if (numValue >= 1000000000) {
                                            return (Number(value) / 1000000).toFixed(0) + ' Mld';
                                        }
                                        if (numValue >= 1000000) {
                                            return (Number(value) / 1000000).toFixed(0) + ' Mln';
                                        }
                                        if (numValue >= 1000) {
                                            return (Number(value) / 1000).toFixed(0) + ' M';
                                        }
                                        return value.toString() + ' ';
                                    },
                                    display: true,
                                    color: '#030303',
                                    font: function (context) {
                                        let avgSize = Math.round((context.chart.height + context.chart.width) / 2);
                                        let size = Math.round(avgSize / 32);
                                        size = size > 17 ? 17 : size;
                                        return {
                                            size: size,
                                            weight: 'normal',
                                            family: "'Titillium Web', sans-serif",
                                        };
                                    },
                                },
                            },
                        },
                        plugins: {
                            tooltip: {
                                enabled: false,
                                position: 'nearest',
                                external: function (context) {
                                    createTooltip(context);

                                    let tooltipEl = document.getElementById('chartjs-tooltip') as HTMLElement;
                                    const tooltipModel = context.tooltip;

                                    const { offsetTop: positionY } = chart.canvas;
                                    tooltipEl.style.opacity = '1';
                                    if (tooltipEl.classList.contains('d-none')) {
                                        tooltipEl.classList.remove('d-none');
                                    }
                                    tooltipEl.style.position = 'absolute';
                                    tooltipEl.style.top = positionY + (tooltipModel.caretY - 110) + 'px';
                                },
                            },
                            legend: {
                                display: false,
                            },
                        },
                    },
                });

                chart.canvas.addEventListener('mouseleave', () => {
                    const tooltipEl = document.getElementById('chartjs-tooltip') as HTMLElement;
                    if (tooltipEl) {
                        tooltipEl.classList.add('d-none');
                    }
                });

                const $labelWrapper = bar.querySelector('.label-wrapper') as HTMLElement;
                data.forEach((item: any) => {
                    const key = Object.keys(item)[0];
                    const labelItem = document.createElement('div');
                    labelItem.classList.add('label-item');
                    const label = document.createElement('div');
                    label.classList.add('label');
                    label.textContent += key;
                    const info = document.createElement('i');
                    info.classList.add('icn-info');

                    labelItem.appendChild(label);
                    labelItem.appendChild(info);
                    $labelWrapper.appendChild(labelItem);
                });

                const $labelItems = bar.querySelectorAll('.label-wrapper .label-item');

                $labelItems.forEach(item => {
                    item.addEventListener('click', () => {
                        const label = item.querySelector('.label') as HTMLElement;
                        const find = results.filter((el: any) => el.tooltip.title === label.innerHTML);

                        if (find) {
                            clearUi();

                            mask.classList.remove('d-none');
                            labelTooltip.classList.remove('d-none');
                            document.body.style.overflow = 'hidden';

                            const title = document.createElement('div');
                            title.classList.add('tooltip-title');
                            const description = document.createElement('div');
                            description.classList.add('tooltip-description');
                            title.textContent += find.map((item: any) => item.tooltip.title);
                            description.textContent += find.map((item: any) => item.tooltip.description);

                            const btnLink = labelTooltip.querySelector('.tooltip-btn>a');
                            btnLink &&
                                btnLink.setAttribute(
                                    'href',
                                    find.map((item: any) => item.tooltip.link)
                                );

                            labelTooltip.appendChild(title);
                            labelTooltip.appendChild(description);
                        }
                    });
                });
            }

            function initSwiperChartMobile() {
                const mobileCarousel = bar.querySelector('.mobile') as HTMLElement;
                const swiperContainer = mobileCarousel.querySelector('.swiper') as HTMLElement;
                swiperContainer.setAttribute('id', `swiper-${index}`);
                const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper') as HTMLElement;
                const swiperBtnNext = mobileCarousel.querySelector('.swiper-button-next') as HTMLElement;
                const swiperBtnPrev = mobileCarousel.querySelector('.swiper-button-prev') as HTMLElement;

                data.forEach((item: any) => {
                    const key = Object.keys(item)[0];
                    const slide = document.createElement('div');
                    slide.classList.add('swiper-slide');

                    const canvas = document.createElement('canvas');
                    canvas.setAttribute('width', '400');
                    canvas.setAttribute('height', '300');
                    canvas.setAttribute('role', 'img');
                    canvas.setAttribute('aria-label', 'grafico a barre verticali');

                    const labelWrapper = document.createElement('div');
                    labelWrapper.classList.add('label-wrapper');
                    const label = document.createElement('div');
                    label.classList.add('label');
                    label.textContent += key;
                    const info = document.createElement('i');
                    info.classList.add('icn-info');

                    labelWrapper.appendChild(label);
                    labelWrapper.appendChild(info);

                    slide.appendChild(canvas);
                    slide.appendChild(labelWrapper);
                    swiperWrapper.appendChild(slide);

                    const values = item[key].values;
                    const labels = values.map((value: any) => value.title);
                    const dataValues = values.map((value: any) => value.value);
                    const colors = values.map((value: any) => value.color);

                    labelWrapper.addEventListener('click', () => {
                        clearUi();

                        mask.classList.remove('d-none');
                        labelTooltip.classList.remove('d-none');
                        document.body.style.overflow = 'hidden';

                        const title = document.createElement('div');
                        title.classList.add('tooltip-title');
                        const description = document.createElement('div');
                        description.classList.add('tooltip-description');
                        title.textContent += item[key]?.tooltip?.title;
                        description.textContent += item[key]?.tooltip?.description;

                        labelTooltip.appendChild(title);
                        labelTooltip.appendChild(description);
                    });

                    const ctx = canvas.getContext('2d') as any;
                    const chart = new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: labels,
                            datasets: [
                                {
                                    label: labels,
                                    data: dataValues,
                                    backgroundColor: colors,
                                    hoverBackgroundColor: colors,
                                },
                            ],
                        },
                        options: {
                            datasets: {
                                bar: {
                                    barPercentage: 1,
                                },
                            },
                            hover: {
                                mode: 'nearest',
                            },
                            responsive: true,
                            maintainAspectRatio: true,
                            scales: {
                                x: {
                                    grid: {
                                        display: false,
                                    },
                                    ticks: {
                                        display: false,
                                    },
                                },
                                y: {
                                    grid: {
                                        display: true,
                                        color: '#ECE9F1',
                                        tickColor: 'transparent',
                                        tickLength: 39,
                                    },
                                    border: {
                                        display: false,
                                    },
                                    beginAtZero: true,
                                    display: true,
                                    ticks: {
                                        callback: function (value: number | string) {
                                            return value.toString().substring(0, 3) + ' M';
                                        },
                                        display: true,
                                        color: '#030303',
                                        font: {
                                            size: 20,
                                            weight: 'normal',
                                            family: "'Titillium Web', sans-serif",
                                        },
                                    },
                                },
                            },
                            plugins: {
                                tooltip: {
                                    enabled: false,
                                    position: 'nearest',
                                    external: function (context) {
                                        createTooltip(context);

                                        let tooltipEl = document.getElementById('chartjs-tooltip') as HTMLElement;
                                        const tooltipModel = context.tooltip;

                                        const { offsetLeft: positionX } = chart.canvas;
                                        tooltipEl.style.opacity = '1';
                                        if (tooltipEl.classList.contains('d-none')) {
                                            tooltipEl.classList.remove('d-none');
                                        }
                                        tooltipEl.style.position = 'absolute';
                                        tooltipEl.style.left = positionX + (tooltipModel.caretX / 2 - 20) + 'px';
                                        tooltipEl.style.top = tooltipModel.caretY + 80 + 'px';
                                    },
                                },
                                legend: {
                                    display: false,
                                },
                            },
                        },
                    });
                });

                const swiper = new Swiper(swiperContainer, {
                    modules: [Navigation, Pagination],
                    slidesPerGroup: 1,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    navigation: {
                        nextEl: swiperBtnNext,
                        prevEl: swiperBtnPrev,
                        addIcons: false,
                    },
                });

                if (swiperBtnNext) {
                    swiperBtnNext.addEventListener('keypress', function (e) {
                        if (e.code === 'Enter') {
                            swiper.slideNext();
                        }
                    });
                }

                if (swiperBtnPrev) {
                    swiperBtnPrev.addEventListener('keypress', function (e) {
                        if (e.code === 'Enter') {
                            swiper.slidePrev();
                        }
                    });
                }

                swiper.init();
            }

            function createTooltip(context: any) {
                let tooltipEl = document.getElementById('chartjs-tooltip') as HTMLElement;
                if (!tooltipEl) {
                    tooltipEl = document.createElement('div');
                    tooltipEl.id = 'chartjs-tooltip';
                    tooltipEl.innerHTML = '<div class="tooltip"></div>';

                    const closeBtn = document.createElement('div');
                    closeBtn.classList.add('close-btn');
                    closeBtn.innerHTML = '                <div class="btn">Chiudi</div>' + '                <i class="icn-close"></i>' + '            </div>';

                    bar.appendChild(tooltipEl);
                    tooltipEl.appendChild(closeBtn);
                }

                document.addEventListener('keydown', e => {
                    if (e.key === 'Escape') {
                        mask.classList.add('d-none');
                        labelTooltip && labelTooltip.classList.add('d-none');
                        document.body.style.overflow = 'scroll';
                    }
                });

                closeTooltip();

                const tooltipModel = context.tooltip;

                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltipModel.yAlign) {
                    tooltipEl.classList.add(tooltipModel.yAlign);
                } else {
                    tooltipEl.classList.add('no-transform');
                }

                function getBody(bodyItem: any) {
                    return bodyItem.formattedValue;
                }

                if (tooltipModel.body) {
                    const titleLines =
                        window.innerWidth > 768 && data.length > 1
                            ? tooltipModel.dataPoints[0].dataset.titlesTooltip[0] || []
                            : window.innerWidth > 768 && data.length === 1
                              ? tooltipModel.dataPoints.map((item: any) => item.label) || []
                              : tooltipModel.title || [];
                    const bodyLines = tooltipModel.dataPoints.map(getBody);

                    let innerHtml = '<div>';
                    innerHtml += '<div class="title-tooltip">' + titleLines + '</div>';

                    bodyLines.forEach(function (body: any) {
                        const span = '<div class="value">' + body.replace(/\,/g, '.') + '</div><span> / €</span>';
                        innerHtml += span;
                    });
                    innerHtml += '</div>';

                    let tableRoot = tooltipEl.querySelector('.tooltip') as HTMLElement;
                    tableRoot.innerHTML = innerHtml;
                }
            }

            function closeTooltip() {
                let tooltipEl = document.getElementById('chartjs-tooltip') as HTMLElement;
                const $closeBtn = tooltipEl.querySelector('.close-btn') as HTMLElement;

                $closeBtn.addEventListener('click', () => {
                    tooltipEl.classList.add('d-none');
                });

                $closeBtn.addEventListener('keypress', e => {
                    if (e.key === 'Enter') {
                        tooltipEl.classList.add('d-none');
                    }
                });

                document.addEventListener('keydown', e => {
                    if (e.key === 'Escape') {
                        tooltipEl.classList.add('d-none');
                    }
                });
            }

            function resize(_matches: any) {
                if (window.innerWidth > 768) {
                    initChartDsk();
                } else {
                    initSwiperChartMobile();
                }
            }

            const mediaQuery = window.matchMedia('(max-width: 768px)');

            mediaQuery.removeEventListener('change', function () {});
            mediaQuery.addEventListener('change', e => resize(e.matches));

            function init() {
                resize(mediaQuery.matches);
            }

            createLegend();
            closeModal();
            init();
        });
    }
}
